import React, { useEffect, useState } from 'react'
import BossDialog from '../../components/BossDialog';
import { ADS_TYPE, ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from '../../framework/constant/constant';
import * as API from '../../framework/API/api';
import { utility } from '../../framework/utility/utilityProvider';
import { EditPageHeader } from '../../components/EditPageHeader';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { MetaChannelForm } from './Meta/MetaChannelForm';
import { GoogleChannelForm } from './Google/GoogleChannelForm';
import LinkedInChannelForm from './LinkedIn/LinkedInChannelForm';
import SMChannelIconForm from './SMChannelIconForm';
import ToastNotification from "../../components/ToastNotification";
import { useTranslation } from '../../locale/useTranslation';

const SMChannelEditForm = (props) => {
    const { item = {}, cancelEdit, refresh } = props;
    const isAddMode = !item?._id ?? false;

    const setData = () => {
        switch (item?.adType) {
            case ADS_TYPE.META:
                return {
                    accessToken: item?.accessToken ?? '',
                    adAccountId: item?.adAccountId ?? '',
                }
            case ADS_TYPE.GOOGLE:
                return {
                    customer_id: item?.customer_id ?? '',
                    client_id: item?.client_id ?? '',
                    client_secret: item?.client_secret ?? '',
                    developer_token: item?.developer_token ?? '',
                    scope: item?.scope ?? '',
                    refresh_token: item?.refresh_token ?? '',
                }
            case ADS_TYPE.LINKEDIN:
                return {
                    client_id: item?.client_id ?? '',
                    client_secret: item?.client_secret ?? '',
                    accountId: item?.accountId ?? '',
                    accessToken: item?.accessToken ?? '',
                }
        }
    }

    const blankDataItem = {
        _id: item?._id,
        adType: item?.adType ? { _id: item?.adType, description: item?.adType } : {},
        lastFetchBalance: utility.convertMilisecondsToDateTimeString(item?.lastFetchBalance),
        apiVersion: item?.apiVersion ?? '',
        baseUrl: item?.baseUrl ?? '',
        ...setData(),
    }

    const [adTypes, setAdTypes] = useState([]);
    const [balance, setBalance] = useState(item?.balance ?? 0);
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [showChannelIconForm, setShowChannelIconForm] = useState(isAddMode);
    const [isPageNotAvailable, setIsPageNotAvailable] = useState(false);

    const lang = useTranslation();

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        const adTypesRes = Object.keys(ADS_TYPE).map(x => ({
            _id: ADS_TYPE[x], description: x
        }));
        setAdTypes(adTypesRes);
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        setDataItem({ ...dataItem, [name]: value });
    };

    const isValid = () => {
        if (!dataItem.adType || Object.keys(dataItem.adType).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please select ads type" });
            return false;
        }
        if (!dataItem.baseUrl || dataItem.baseUrl === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please enter base url" });
            return false;
        }
        if (dataItem?.adType?._id !== ADS_TYPE.LINKEDIN && !dataItem.apiVersion || dataItem.apiVersion === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please enter api version" });
            return false;
        }
        switch (dataItem.adType?._id) {
            case ADS_TYPE.META:
                if (!dataItem.adAccountId || dataItem.adAccountId === "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please enter ad account id" });
                    return false;
                } else if (!dataItem.accessToken || dataItem.accessToken === "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please enter access token" });
                    return false;
                }
                break;
            case ADS_TYPE.GOOGLE:
                if (!dataItem.customer_id || dataItem.customer_id === "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please enter customer id" });
                    return false;
                } else if (!dataItem.client_id || dataItem.client_id === "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please enter client id" });
                    return false;
                } else if (!dataItem.client_secret || dataItem.client_secret === "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please enter client secret" });
                    return false;
                } else if (!dataItem.developer_token || dataItem.developer_token === "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please enter developer token" });
                    return false;
                } else if (!dataItem.scope || dataItem.scope === "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please enter scope" });
                    return false;
                }
                break;
            case ADS_TYPE.LINKEDIN:
                if (!dataItem.accountId || dataItem.accountId === "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please enter account id" });
                    return false;
                } else if (!dataItem.client_id || dataItem.client_id === "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please enter client id" });
                    return false;
                } else if (!dataItem.client_secret || dataItem.client_secret === "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please enter client secret" });
                    return false;
                }
                break;
        }
        return true;
    }

    const handleSelectedChannel = (selectedAdType) => {
        let adType = adTypes.find(x => x.description === selectedAdType);
        setDataItem({ ...dataItem, adType: adType });
        setShowChannelIconForm(false);
    };

    const getFinalData = () => {
        switch (dataItem.adType._id) {
            case ADS_TYPE.META:
                return {
                    accessToken: dataItem.accessToken,
                    adAccountId: dataItem.adAccountId,
                };
            case ADS_TYPE.GOOGLE:
                return {
                    customer_id: dataItem.customer_id,
                    client_id: dataItem.client_id,
                    client_secret: dataItem.client_secret,
                    developer_token: dataItem.developer_token,
                    scope: dataItem.scope,
                    refresh_token: dataItem.refresh_token,
                };
            case ADS_TYPE.LINKEDIN:
                return {
                    client_id: dataItem.client_id,
                    client_secret: dataItem.client_secret,
                    accountId: dataItem.accountId,
                    accessToken: dataItem.accessToken,
                };
            default:
                return {};
        }
    };

    const getBalance = async (isAlert = false) => {
        const res = await API.getAmount({
            adsConfig: { ...dataItem, adType: dataItem?.adType?._id },
            fields: "spend_cap,amount_spent,balance,account_status"
        });

        if (!res?.success) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            setBalance(0);
            return;
        }

        const newBalance = res?.data ?? 0;
        const newFetchTime = Date.now();

        const finalData = {
            _id: dataItem._id,
            balance: parseFloat(newBalance),
            lastFetchBalance: newFetchTime,
        };

        const saveRes = await API.saveData(ENTITYNAME.SM_Channels, finalData);
        if (saveRes?.success) {
            utility.deleteLocalStorageItem(ENTITYNAME.SM_Channels);
            isAlert && ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
        } else {
            isAlert && ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: saveRes.message });
        }

        setBalance(newBalance);
        refresh && refresh();
    };

    const handleSubmit = async () => {
        if (!isValid()) return;

        const finalData = {
            _id: dataItem._id,
            adType: dataItem.adType._id,
            baseUrl: dataItem.baseUrl,
            apiVersion: dataItem.apiVersion,
            balance: balance ? parseFloat(balance) : 0,
            lastFetchBalance: dataItem?.lastFetchBalance ? new Date(dataItem?.lastFetchBalance).valueOf() : new Date().valueOf(),
            ...getFinalData(),
        };

        if (dataItem.adType._id === ADS_TYPE.META) {
            const response = await API.getMetaPages({ adsConfig: finalData, fields: "id,name" });
            if (!response?.data?.length) {
                setIsPageNotAvailable(true);
                return;
            }
        }

        const res = await API.saveData(ENTITYNAME.SM_Channels, finalData);
        if (res?.success) {
            const logData = {
                event: res.message === "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT,
                module: MODULE.SM_CHANNELS,
                data: res.data,
                message: res.message
            };
            await API.SaveLogs(logData);
            utility.deleteLocalStorageItem(ENTITYNAME.SM_Channels);
            cancelEdit && cancelEdit();
            refresh && refresh();
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    };

    const hyperlink = (value) => (
        <a onClick={() => window.open(value, "_blank")} style={{ cursor: "pointer", color: "blue" }}>{value}</a>
    );

    return (
        showChannelIconForm ? <SMChannelIconForm handleCancel={cancelEdit} handleSelectedChannel={handleSelectedChannel} /> :
        <BossDialog title="Social Media Channel" onClose={cancelEdit} width={"800px"}>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <EditPageHeader showTitle={false} onSubmit={handleSubmit} onCancel={cancelEdit} />
                {dataItem?._id && (
                    <div className="d-flex align-items-center" style={{ width: "40%" }}>
                        <RoundButton onClick={() => getBalance(true)} title="Refresh Balance" icon="refresh" />
                        <div className='ml-2'>{`Available Balance: ${balance}`}</div>
                    </div>
                )}
            </div>
            <div className='row'>
                <div className="col-6">
                    <label htmlFor="title">Ad Type *</label>
                    <DropDownList
                        name="adType"
                        textField="description"
                        dataItemKey="_id"
                        data={adTypes}
                        value={dataItem?.adType}
                        onChange={onChange}
                        disabled={isAddMode}
                    />
                </div>
                <div className='col-6'>
                    <label htmlFor="baseUrl">Base URL *</label>
                    <input
                        type="text"
                        name="baseUrl"
                        className='form-control form-control-sm'
                        placeholder="Enter Base URL"
                        value={dataItem?.baseUrl}
                        onChange={onChange}
                    />
                </div>
                {dataItem?.adType?._id !== ADS_TYPE.LINKEDIN &&<div className='col-6 mt-2'>
                    <label htmlFor="apiVersion">API Version * <span className="ml-2">Ex: v19</span></label>
                    <input
                        type="text"
                        name="apiVersion"
                        className='form-control form-control-sm'
                        placeholder="Enter API Version"
                        value={dataItem?.apiVersion}
                        onChange={onChange}
                    />
                </div>}
                {dataItem?.adType?._id === ADS_TYPE.META && <MetaChannelForm dataItem={dataItem} onChange={onChange} />}
                {dataItem?.adType?._id === ADS_TYPE.GOOGLE && <GoogleChannelForm dataItem={dataItem} onChange={onChange} />}
                {dataItem?.adType?._id === ADS_TYPE.LINKEDIN && <LinkedInChannelForm dataItem={dataItem} onChange={onChange} />}
            </div>

            {isPageNotAvailable && (
                <div className='mt-4 font-bold'>
                    No Facebook pages are linked to this account. Please create a page to continue managing your campaigns :
                    {hyperlink("https://www.facebook.com/pages/create")}
                </div>
            )}
        </BossDialog>
    );
};


export default SMChannelEditForm